<script setup lang="ts">
import { SbSectionedList } from "@unio/saltbox-ui"
import { computed } from "vue"

import DetailRow from "@/components/DetailRow.vue"

const props = defineProps<{
  parentName?: string | null
  personName?: string | null
  assetCode?: string | null
  barcode?: string | null
  modelNumber?: string | null
  serialNumber?: string | null
}>()

const visible = computed(
  () =>
    props.parentName ||
    props.personName ||
    props.assetCode ||
    props.barcode ||
    props.modelNumber ||
    props.serialNumber,
)
</script>

<template>
  <SbSectionedList v-if="visible" label="Details" bordered>
    <DetailRow v-if="parentName" label="Container" :value="parentName" />
    <DetailRow v-if="personName" label="Owner" :value="personName" />
    <DetailRow v-if="assetCode" label="Asset code" :value="assetCode" mono />
    <DetailRow v-if="barcode" label="Barcode" :value="barcode" mono />
    <DetailRow v-if="modelNumber" label="Model" :value="modelNumber" mono />
    <DetailRow v-if="serialNumber" label="Serial" :value="serialNumber" mono />
  </SbSectionedList>
</template>
